// useReducer with Typescript:
// https://github.com/hswolff/youtube/blob/master/videos/why-i-love-usereducer/src/LoginUseReducerTypeScript.tsx

import React, { useReducer, ReactNode } from 'react';
import { createContext } from 'use-context-selector';
import _ from 'lodash';

const initialState: ITooltipState = {
  visibleTooltips: '',
  showTooltip: () => {},
  hideTooltip: () => {},
  hideAllTooltips: () => {},
};

type ITooltipState = {
  visibleTooltips: string;
  showTooltip: (tolltipId: string) => void;
  hideTooltip: (tolltipId: string) => void;
  hideAllTooltips: () => void;
};

type ITooltipAction =
  | { type: 'SHOW_TOOLTIP'; payload: string }
  | { type: 'HIDE_TOOLTIP'; payload: string }
  | { type: 'HIDE_ALL_TOOLTIPS' };

function tooltipReducer(
  state: ITooltipState,
  action: ITooltipAction
): ITooltipState {
  switch (action.type) {
    case 'SHOW_TOOLTIP':
      return {
        ...state,
        visibleTooltips: [
          ...state.visibleTooltips.split(','),
          action.payload,
        ].join(','),
      };
    case 'HIDE_TOOLTIP':
      const updatedVisibleTooltips = state.visibleTooltips.split(',');
      return {
        ...state,
        visibleTooltips: _.filter(
          updatedVisibleTooltips,
          (t) => t !== action.payload
        ).join(','),
      };
    case 'HIDE_ALL_TOOLTIPS':
      return {
        ...state,
        visibleTooltips: '',
      };
    default:
      return state;
  }
}

export const TooltipContext = createContext(initialState as ITooltipState);

export default function TooltipProvider(props: { children: ReactNode }) {
  const [state, dispatch] = useReducer(tooltipReducer, initialState);

  // Actions
  // reminder: always dispatch; otherwise, is a SELECTOR, not an ACTION
  function showTooltip(tooltipId: string) {
    dispatch({
      type: 'SHOW_TOOLTIP',
      payload: tooltipId,
    });
  }

  function hideTooltip(tooltipId: string) {
    dispatch({
      type: 'HIDE_TOOLTIP',
      payload: tooltipId,
    });
  }

  function hideAllTooltips() {
    dispatch({
      type: 'HIDE_ALL_TOOLTIPS',
    });
  }

  return (
    <TooltipContext.Provider
      value={{
        ...state,
        showTooltip,
        hideTooltip,
        hideAllTooltips,
      }}
    >
      {props.children}
    </TooltipContext.Provider>
  );
}
